import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notification, NOTIFICATIONS_STORE_NAME, NotificationType } from 'src/app/common/model/notification';
import { AlcoholTestRequestDeliveredResponse } from '../model/alcohol-test/alcohol-test-request-delivered-response';
import { plainToClass } from 'class-transformer';
import { WebsocketClient } from 'src/app/common/service/websocket-client.service';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { StoreService } from 'src/app/store/service/store.service';
import { map } from 'rxjs/operators';
import { WEBSOCKET_TOPIC_ALCOHOL_TEST_REQUEST_DELIVERED as WEBSOCKET_TOPIC_ALCOHOL_TEST_REQUEST_DELIVERED } from 'src/app/common/const';

@Injectable({
  providedIn: 'root'
})
export class AlcoholTestNotifierService {

  alcoholTestResponseSubscription: Subscription;

  constructor(private websocketClient: WebsocketClient,
    private storeService: StoreService, private settings: UserSettingsService) { }


  init(): void {
    if (this.settings.isAlcoholTestRequestEnable()) {
      this.websocketClient.websocketConnectionConnected$
        .subscribe(() => {
          this.connectToAlcoholTestTopic();
        });
    }
  }

  private connectToAlcoholTestTopic(): void {
    this.alcoholTestResponseSubscription = this.websocketClient.subscribe(WEBSOCKET_TOPIC_ALCOHOL_TEST_REQUEST_DELIVERED).pipe(
      map(response => plainToClass(AlcoholTestRequestDeliveredResponse, response)))
      .subscribe(resp => this.storeService.store<Notification>(
        NOTIFICATIONS_STORE_NAME,
        [{ type: NotificationType.ALCOHOL_TEST_REQUEST_DELIVERED, time: new Date(), data: resp }]
      ));
  }

  public unsubscribe(): void {
    this.alcoholTestResponseSubscription.unsubscribe();
  }
}
